<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" (click)="closed.emit()">
  <div class="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl dark:bg-gray-800" (click)="$event.stopPropagation()" cdkTrapFocus>
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">{{ 'lead_pipelines.modals.unlock_email.title' | translate }}</h2>
    <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
      {{ 'lead_pipelines.modals.unlock_email.body' | translate:{ cost: cost, name: personName } }}
    </p>
    <div class="mt-6 flex justify-end gap-2">
      <app-lp-button variant="secondary" (pressed)="closed.emit()">{{ 'lead_pipelines.wizard.cancel' | translate }}</app-lp-button>
      <app-lp-button variant="primary" (pressed)="confirm.emit()">{{ 'lead_pipelines.modals.unlock_email.confirm' | translate }}</app-lp-button>
    </div>
  </div>
</div>
